const countries = [
  {
    name: "Ascension Island",
    code: "AC",
    dial: "+247",
    flag: "https://flagcdn.com/w20/sh.png",
  },
  {
    name: "Andorra",
    code: "AD",
    dial: "+376",
    flag: "https://flagcdn.com/w20/ad.png",
  },
  {
    name: "United Arab Emirates",
    code: "AE",
    dial: "+971",
    flag: "https://flagcdn.com/w20/ae.png",
  },
  {
    name: "Afghanistan",
    code: "AF",
    dial: "+93",
    flag: "https://flagcdn.com/w20/af.png",
  },
  {
    name: "Antigua and Barbuda",
    code: "AG",
    dial: "+1",
    flag: "https://flagcdn.com/w20/ag.png",
  },
  {
    name: "Anguilla",
    code: "AI",
    dial: "+1",
    flag: "https://flagcdn.com/w20/ai.png",
  },
  {
    name: "Albania",
    code: "AL",
    dial: "+355",
    flag: "https://flagcdn.com/w20/al.png",
  },
  {
    name: "Armenia",
    code: "AM",
    dial: "+374",
    flag: "https://flagcdn.com/w20/am.png",
  },
  {
    name: "Angola",
    code: "AO",
    dial: "+244",
    flag: "https://flagcdn.com/w20/ao.png",
  },
  {
    name: "Singapore",
    code: "SG",
    dial: "+65",
    flag: "https://flagcdn.com/w20/sg.png",
  },
  {
    name: "Vietnam",
    code: "VN",
    dial: "+84",
    flag: "https://flagcdn.com/w20/vn.png",
  },
  // ===== Europe =====
  {
    name: "France",
    code: "FR",
    dial: "+33",
    flag: "https://flagcdn.com/w20/fr.png",
  },
  {
    name: "Germany",
    code: "DE",
    dial: "+49",
    flag: "https://flagcdn.com/w20/de.png",
  },
  {
    name: "Italy",
    code: "IT",
    dial: "+39",
    flag: "https://flagcdn.com/w20/it.png",
  },
  {
    name: "Spain",
    code: "ES",
    dial: "+34",
    flag: "https://flagcdn.com/w20/es.png",
  },
  {
    name: "United Kingdom",
    code: "GB",
    dial: "+44",
    flag: "https://flagcdn.com/w20/gb.png",
  },
  {
    name: "Netherlands",
    code: "NL",
    dial: "+31",
    flag: "https://flagcdn.com/w20/nl.png",
  },
  {
    name: "Sweden",
    code: "SE",
    dial: "+46",
    flag: "https://flagcdn.com/w20/se.png",
  },

  // ===== Asia =====
  {
    name: "China",
    code: "CN",
    dial: "+86",
    flag: "https://flagcdn.com/w20/cn.png",
  },
  {
    name: "Japan",
    code: "JP",
    dial: "+81",
    flag: "https://flagcdn.com/w20/jp.png",
  },
  {
    name: "South Korea",
    code: "KR",
    dial: "+82",
    flag: "https://flagcdn.com/w20/kr.png",
  },
  {
    name: "Thailand",
    code: "TH",
    dial: "+66",
    flag: "https://flagcdn.com/w20/th.png",
  },
  {
    name: "Malaysia",
    code: "MY",
    dial: "+60",
    flag: "https://flagcdn.com/w20/my.png",
  },
  {
    name: "Indonesia",
    code: "ID",
    dial: "+62",
    flag: "https://flagcdn.com/w20/id.png",
  },
  {
    name: "Philippines",
    code: "PH",
    dial: "+63",
    flag: "https://flagcdn.com/w20/ph.png",
  },
  {
    name: "India",
    code: "IN",
    dial: "+91",
    flag: "https://flagcdn.com/w20/in.png",
  },

  // ===== North America =====
  {
    name: "United States",
    code: "US",
    dial: "+1",
    flag: "https://flagcdn.com/w20/us.png",
  },
  {
    name: "Canada",
    code: "CA",
    dial: "+1",
    flag: "https://flagcdn.com/w20/ca.png",
  },
  {
    name: "Mexico",
    code: "MX",
    dial: "+52",
    flag: "https://flagcdn.com/w20/mx.png",
  },

  // ===== South America =====
  {
    name: "Brazil",
    code: "BR",
    dial: "+55",
    flag: "https://flagcdn.com/w20/br.png",
  },
  {
    name: "Argentina",
    code: "AR",
    dial: "+54",
    flag: "https://flagcdn.com/w20/ar.png",
  },
  {
    name: "Chile",
    code: "CL",
    dial: "+56",
    flag: "https://flagcdn.com/w20/cl.png",
  },

  // ===== Oceania =====
  {
    name: "Australia",
    code: "AU",
    dial: "+61",
    flag: "https://flagcdn.com/w20/au.png",
  },
  {
    name: "New Zealand",
    code: "NZ",
    dial: "+64",
    flag: "https://flagcdn.com/w20/nz.png",
  },

  // ===== Middle East =====
  {
    name: "Saudi Arabia",
    code: "SA",
    dial: "+966",
    flag: "https://flagcdn.com/w20/sa.png",
  },
  {
    name: "Qatar",
    code: "QA",
    dial: "+974",
    flag: "https://flagcdn.com/w20/qa.png",
  },
  {
    name: "Israel",
    code: "IL",
    dial: "+972",
    flag: "https://flagcdn.com/w20/il.png",
  },

  // ===== Africa =====
  {
    name: "South Africa",
    code: "ZA",
    dial: "+27",
    flag: "https://flagcdn.com/w20/za.png",
  },
  {
    name: "Egypt",
    code: "EG",
    dial: "+20",
    flag: "https://flagcdn.com/w20/eg.png",
  },
  {
    name: "Nigeria",
    code: "NG",
    dial: "+234",
    flag: "https://flagcdn.com/w20/ng.png",
  },
];

export default countries;
